import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import useAuthStore from '../store/authStore';
import { addLink } from '../lib/utils';
import YTEmbed from './YoutubeEmbed';
import { storage } from '../lib/firebase';
import { ref, getDownloadURL } from 'firebase/storage';
import GifEmbed from './GifEmbed';

const ChatMessage = (props) => {
  const textMessage = props.payload.text;
  const id = props.payload.id;
  const userDetails = useAuthStore((state) => state.userDetails);
  const uid = props.payload.uid;
  const dateTime = props.payload.createdAt.seconds;
  const formattedDateTime = format(new Date(dateTime * 1000), 'HH:mm');
  const imageName = props.payload.imageName;
  const [imageUrl, setImageUrl] = useState('');
  const videoName = props.payload.videoName;
  const [videoUrl, setVideoUrl] = useState('');
  const reactions = props.payload.reactions;
  const quickReaction = reactions?.quick_reaction.length;
  const replyTo = props.payload.replyTo;
  const [replyToImgUrl, setReplyToImgUrl] = useState('');
  const [replyToVideoUrl, setReplyToVideoUrl] = useState('');
  const replyToImageName = props.payload?.replyTo?.imageName;
  const replyToVideoName = props.payload?.replyTo?.videoName;

  useEffect(() => {
    if (imageName) {
      const fetchImage = async () => {
        try {
          const url = await getDownloadURL(
            ref(storage, 'uploads/' + imageName)
          );
          setImageUrl(url);
        } catch (error) {
          console.error('Error fetching image:', error);
        }
      };

      fetchImage();
    }

    if (replyToVideoName) {
      const fetchReplyToVideo = async () => {
        try {
          const url = await getDownloadURL(
            ref(storage, 'uploads/' + replyToVideoName)
          );
          setReplyToVideoUrl(url);
        } catch (error) {
          console.error('Error fetching image:', error);
        }
      };

      fetchReplyToVideo();
    }

    if (replyToImageName) {
      const fetchReplyToImg = async () => {
        try {
          const url = await getDownloadURL(
            ref(storage, 'uploads/' + replyToImageName)
          );
          setReplyToImgUrl(url);
        } catch (error) {
          console.error('Error fetching image:', error);
        }
      };

      fetchReplyToImg();
    }

    if (videoName) {
      const fetchVideo = async () => {
        try {
          const url = await getDownloadURL(
            ref(storage, 'uploads/' + videoName)
          );
          setVideoUrl(url);
        } catch (error) {
          console.error('Error fetching image:', error);
        }
      };

      fetchVideo();
    }
  }, [imageName, videoName]);

  let buildMessageTemplate;

  if (userDetails.uid === uid) {
    buildMessageTemplate = (
      <div
        key={id}
        className="end-xs msg-wrapper-master msg-bubble-self-wrapper"
      >
        {replyTo && (
          <div>
            <div className="reply-to-msg">
              {replyTo.text ? (
                <>
                  {addLink(replyTo.text)}
                  <YTEmbed text={replyTo.text} />
                  <GifEmbed text={replyTo.text} />
                </>
              ) : replyTo.videoName ? (
                <>
                  <video
                    src={replyToVideoUrl}
                    controls
                    controlsList="nodownload"
                    onContextMenu={(e) => {
                      e.preventDefault();
                    }}
                  >
                    Your browser does not support the video tag.
                  </video>
                </>
              ) : (
                <img
                  src={replyToImgUrl}
                  alt={replyToImageName}
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                />
              )}
            </div>
          </div>
        )}

        <div className="msg-bubble-wrapper">
          <div className="msg-bubble-self" onContextMenu={props.contextMenu}>
            {imageName ? (
              <>
                <img
                  src={imageUrl}
                  alt={imageName}
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                />
                <time>{formattedDateTime}</time>
              </>
            ) : videoName ? (
              <>
                <video
                  src={videoUrl}
                  controls
                  controlsList="nodownload"
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                >
                  Your browser does not support the video tag.
                </video>
                <time>{formattedDateTime}</time>
              </>
            ) : (
              <>
                {addLink(textMessage)}
                <YTEmbed text={textMessage} />
                <GifEmbed text={textMessage} />
                <time>{formattedDateTime}</time>
              </>
            )}
            {quickReaction > 0 && <span className="quick-reaction">❤️</span>}
          </div>
        </div>
      </div>
    );
  } else {
    buildMessageTemplate = (
      <div
        key={id}
        className="start-xs msg-wrapper-master msg-bubble-other-wrapper"
      >
        {replyTo && (
          <div>
            <div className="reply-to-msg">
              {replyTo.text ? (
                <>
                  {addLink(replyTo.text)}
                  <YTEmbed text={replyTo.text} />
                  <GifEmbed text={replyTo.text} />
                </>
              ) : replyTo.videoName ? (
                <>
                  <video
                    src={replyToVideoUrl}
                    controls
                    controlsList="nodownload"
                    onContextMenu={(e) => {
                      e.preventDefault();
                    }}
                  >
                    Your browser does not support the video tag.
                  </video>
                </>
              ) : (
                <img
                  src={replyToImgUrl}
                  alt={replyToImageName}
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                />
              )}
            </div>
          </div>
        )}
        <div className="msg-bubble-wrapper">
          <div
            className="msg-bubble-others"
            onDoubleClick={props.sendHeartReaction}
            onContextMenu={props.contextMenu}
          >
            {imageName ? (
              <>
                <img
                  src={imageUrl}
                  alt={imageName}
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                />
                <time>{formattedDateTime}</time>
              </>
            ) : videoName ? (
              <>
                <video
                  src={videoUrl}
                  controls
                  controlsList="nodownload"
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                >
                  Your browser does not support the video tag.
                </video>
                <time>{formattedDateTime}</time>
              </>
            ) : (
              <>
                {addLink(textMessage)}
                <YTEmbed text={textMessage} />
                <GifEmbed text={textMessage} />
                <time>{formattedDateTime}</time>
              </>
            )}
            {quickReaction > 0 && <span className="quick-reaction">❤️</span>}
          </div>
        </div>
      </div>
    );
  }

  return buildMessageTemplate;
};

export default ChatMessage;
